import { TableCell, TableRow } from "@/shared/components/ui/table";
import t from "@/lang/lang";

export function TableEmptyRow({
  colSpan,
  text = t("Keine Daten"),
}: {
  colSpan: number;
  text?: string;
}) {
  return (
    <TableRow>
      <TableCell colSpan={colSpan} className="text-center">
        <span>{text}</span>
      </TableCell>
    </TableRow>
  );
}
